export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.avatarDropdown.personalProfile': 'Personal Profile',
  'component.avatarDropdown.personalSettings': 'Personal Settings',
  'component.avatarDropdown.logout': 'Logout',
  'component.contextSwitcher.select': 'Select position',
  'component.contextSwitcher.fallback': 'Position',
  'component.contextSwitcher.reset': 'Return to main profile',
  'component.contextSwitcher.switchFailed': 'Failed to switch context',
  'component.contextSwitcher.org.methodologicalDepartment': 'Methodological department',
  'component.contextSwitcher.org.developmentDepartment': 'Development department',
  'component.positionGate.title': 'Select a position',
  'component.positionGate.description':
    'You work on behalf of a single position: each one has its own permissions and interface. The position can be changed in the header.',
  'component.themeSwitch.toDark': 'Dark theme',
  'component.themeSwitch.toLight': 'Light theme',
  'component.workArea.drag': 'Move',
  'component.workArea.collapse': 'Collapse',
  'component.workArea.expand': 'Expand',
  'component.workArea.empty': 'All frames are collapsed',
};
